import { useEffect } from 'react';
import { useSettings } from 'hooks/useSettings';
import { useSecurityGroupConfig } from 'contexts/SecurityGroupConfigContext';

/**
 * Component that syncs settings to the security group config context.
 * Should be rendered inside both SecurityGroupConfigProvider and after auth is established.
 * Updates security group mappings when settings are loaded/changed.
 */
export function SettingsSecuritySync(): null {
  const { settings, isLoading } = useSettings();
  const { updateFromSettings } = useSecurityGroupConfig();

  useEffect(() => {
    if (!isLoading) {
      // Update security group config from settings
      updateFromSettings(settings.groupConfigs);
    }
  }, [settings.groupConfigs, isLoading, updateFromSettings]);

  return null;
}
